import Email from "../email";
import Phone from "../phone";
import TeamPhone from "../team-phone";
import PropTypes from "prop-types";
import React from "react";
import Social from "../social/social";
import "./header-top.scss";
import { showFairHousingNotice, validate2AgentTeam } from "../util";

const HeaderTop = ({ entity }) => {
  return (
    <div className="header-top until-md">
      <div className="header-top-inner">
        <div className="header-contact">
          {entity && validate2AgentTeam(entity) ? (
            <TeamPhone entity={entity} prefix="Tel" separator={true} />
          ) : (
            <span>
              <Phone number={entity.primaryPhone} prefix="Tel" />
              <span className="slash-separator">/</span>
            </span>
          )}

          <Email email={entity.emailAddress} />
        </div>
        <div className="header-top-right">
          {showFairHousingNotice(entity) && (
            <div>
              <a
                href="https://www.dos.ny.gov/licensing/docs/FairHousingNotice_new.pdf"
                target="_blank"
              >
                Fair Housing Notice
              </a>
            </div>
          )}
          <div>
            <Social socials={entity.socials} />
          </div>
        </div>
      </div>
    </div>
  );
};

HeaderTop.propTypes = {
  entity: PropTypes.object.isRequired,
};

export default HeaderTop;



// WEBPACK FOOTER //
// ./src/components/shared/header-top/header-top.js